import { render, staticRenderFns } from "./PayslipView.vue?vue&type=template&id=77286143"
import script from "./PayslipView.vue?vue&type=script&lang=js"
export * from "./PayslipView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports